<template>
  <div class="invitationClientManage">
    <el-form ref="form" label-width="120px" inline @submit.native.prevent>
      <div class="invitationClientManage-form">
        <el-form-item label="客户姓名" style="margin-bottom: 0;">
          <el-input placeholder="全部" v-model="searchParams.name" clearable @keyup.enter.native="queryData(1)"></el-input>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select v-model="searchParams.channel" placeholder="全部" collapse-tags clearable multiple filterable>
            <template v-for="item in channelOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道经理">
          <el-select v-model="searchParams.channelManager" placeholder="全部" collapse-tags clearable multiple filterable>
            <template v-for="item in channelManagerOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-for="(formItem, formIndex) in queryFormList"
          :key="formIndex"
          :label="formItem.label"
        >
          <el-select
            v-if="formItem.type === 'select'"
            v-model="searchParams[formItem.key]"
            placeholder="全部"
            collapse-tags
            clearable
            multiple
            filterable
          >
            <el-option
              v-for="item in formItem.options"
              :label="item.label"
              :value="item.value"
              :key="item.label"
            />
          </el-select>
          <el-input
            v-else
            v-model="searchParams[formItem.key]"
            placeholder="全部"
            clearable
          ></el-input>
        </el-form-item>
      </div>
      
      <el-form-item style="margin-top: 5px; display: flex; justify-content: flex-end;">
        <el-button @click="queryData(1)">查询</el-button>
        <el-button @click="onReset()">重置</el-button>
        <el-button @click="toggleVisiable()">个人新增</el-button>
        <el-button @click="toggleImportVisiable">批量新增</el-button>
        <el-button @click="exportData">导出白名单</el-button>
        <el-button @click="onBatchSend" :loading="inviteEmailLoading" >发送邀请邮件</el-button>
      </el-form-item>
    </el-form>
    <div style="flex: 5;overflow: auto">
      <div style="text-align: right;margin-top: 5px;font-weight: bold;">人数：{{ total }}</div>
      <el-table :data="tableData" border style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
      >
        <el-table-column
          type="selection"
          :selectable="selectable"
          width="55">
        </el-table-column>
        
        <el-table-column
          v-for="item in tableColumns"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :width="item.width"
          :min-width="item.width || 120"
        >
          <template slot-scope="scope">
            <template v-if="item.type === 'select'">
              {{ getSelectLabel(item, scope.row) }}
            </template>
            <template v-else>{{ scope.row[item.prop] }}</template>
          </template>
        </el-table-column>

        <el-table-column label="邮件" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button @click="emailSending([scope.row.clientId])" class="table-button"
              :disabled="!selectable(scope.row)"
            >发邮件</el-button>
            <el-button @click="emailRecords(scope.row)" class="table-button">邮件记录</el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button @click="deleteClient(scope.row.clientId)" class="table-button">删除</el-button>
            <el-button @click="toggleVisiable(scope.row)" class="table-button">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="sizes, prev, pager, next" class="hr"
      :page-sizes="[10, 20, 30]" :page-size='pageSize'
      @size-change="handleSizeChange" @current-change="queryDataByPage" :current-page="currentPage" :total="total">
      </el-pagination>
    </div>
    <el-dialog :title="addOrUpdateTitle" :visible.sync="addOrUpdateVisiable" width="800px" @close="closeAddOrUpdate">
      <el-form ref="addOrUpdateForm" label-width="110px" :model="addOrUpdateForm" :rules="rules" inline>
        <el-form-item
          v-for="item in columns"
          :label="item.label"
          :key="item.prop"
          style="width: 45%;"
          :prop="item.prop"
        >
          <el-select
            v-if="item.type === 'select'"
            v-model="addOrUpdateForm[item.prop]"
            placeholder="请选择"
            :clearable="item.clearable"
            filterable
          >
            <el-option
              v-for="opIt in item.options"
              :label="opIt.label"
              :value="opIt.value"
              :key="opIt.label"
            />
          </el-select>

          <el-input
            v-else
            v-model="addOrUpdateForm[item.prop]"
            :placeholder="item.placeholder || '请输入'"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button style="width: 150px;" @click="addOrUpdateClient">{{ addOrUpdateForm.clientId ? "更 新" : "新 增" }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量新增" :visible.sync="importVisiable" width="998px" @close="" class="invitation-import-dialog">
      <div>
        <el-upload :action="actionUrl" :show-file-list="false" :with-credentials=true :http-request="onUpload"
                   accept=".xls,.xlsx,.XLS,.XLSX" with-credentials ref="rebateUpload" class="upload-button">
          <el-button>导入Excel</el-button>
        </el-upload>
        <el-button @click="downloadTemplate">下载批量导入模板</el-button>
      </div>
      <p v-if="importData.length > 0" :style="{color:importError ? 'red' : ''}">
        {{ importError ? '导入失败，用户数据存在错误，请查看明细' : "导入成功，请查看明细" }}
      </p>
      <el-table :data="importData" border style="width: 100%" v-show="importData.length > 0">
        <template v-for="item in addTableColumns">
          <el-table-column :prop="item.prop" :label="item.label" :key="item.prop"></el-table-column>
        </template>
        <el-table-column label="错误原因" prop="message" v-if="importError"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="发送记录" :visible.sync="recordsVisible" width="600px" @close="onRecordsClose">
      <el-table :data="recordsList" border style="width: 100%">
        <el-table-column label="发送时间" prop="updateTime">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {addOrUpdateOrDeleteClient, queryClientList, importClient, getQueryChannel, getQueryChannelManager, sendInviteEmail, queryEmailRecord} from '@/service/adminApis'
import {concatUrl} from '@/service/base'
import {EventId as eventId} from '@/util/constants'
import lodash from 'lodash'
import {getMobileTest, isValidEmail} from '@/util/common'
import {OperationAdd, OperationEdit, OperationDel} from '@/util/constants'
import moment from 'moment'
import { WHETHER_LIST, WHETHER_YES, WHETHER_NO } from '@/common/index';
import { localCache } from '@gyasset/shared/utils';

export default {
  name: "invitationClientManage",
  data() {
    return {
      multipleSelection: [],
      WHETHER_LIST,
      queryFormList: [
        { label: '纸质邀请函', key: 'paperInvite', type: 'select',  options: WHETHER_LIST },
        { label: '是否可寄送', key: 'canSendPaper', type: 'select',  options: WHETHER_LIST },
        { label: '寄送信息', key: 'sendInfo' },
        { label: '是否可发送邮件', key: 'canSendEmail', type: 'select',  options: WHETHER_LIST },
        { label: '是否发送邮件', key: 'isSendEmail', type: 'select',  options: WHETHER_LIST },
        { label: '是否已寄出', key: 'isSendPaper', type: 'select',  options: WHETHER_LIST },
      ],
      searchParams: {
        name: "",
        channel: [],
        channelManager: [],
      },
      tableData: [],
      columns: [
        {prop: 'name', label: "客户姓名", width: 90, fixed: 'left'},
        {prop: 'channel', label: "渠道", width: 90, fixed: 'left'},
        {prop: 'channelManager', label: "渠道经理", width: 90},
        {prop: 'branch', label: "分支", width: 90},
        {prop: 'position', label: "职位", width: 90},
        {prop: 'email', label: "邮箱", placeholder: '请输入邮箱'},
        {prop: 'ccMail', label: "邮箱其他抄送人", placeholder: '请输入邮箱；多个邮箱用“;”分割' },
        {prop: 'paperInvite', label: "纸质邀请函", width: 100, type: 'select',  options: WHETHER_LIST, clearable: true},
        {prop: 'canSendPaper', label: "是否可寄送", width: 100, type: 'select',  options: WHETHER_LIST, clearable: true},
        {prop: 'isSendPaper', label: "是否已寄送", width: 100, type: 'select',  options: WHETHER_LIST, clearable: true},
        {prop: 'sendInfo', label: "寄送信息", width: 90},
        {prop: 'canSendEmail', label: "是否可发送邮件", width: 120, type: 'select', options: WHETHER_LIST},
        {prop: 'phone', label: "手机号", width: 110},
        {prop: 'orderNum', label: "排序", onTable: true},
      ],
      historyData: [],
      addOrUpdateTitle: "新增个人",
      addOrUpdateVisiable: false,
      addOrUpdateForm: {
        channel: "",
        branch: '',
        position: "",
        // emailAddress: '',
        name: "",
        channelManager: "",
        phone: "",
        clientId: "",
        email: '',
        ccMail: '',
        paperInvite: WHETHER_NO,
        canSendPaper: '',
        isSendPaper: '',
        sendInfo: '',
        canSendEmail: WHETHER_NO,
        orderNum: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入客户姓名', trigger: 'blur'},
        ],
        branch: [
          {required: true, message: '请输入分支', trigger: 'blur'},
        ],
        channel: [
          {required: true, message: '请输入渠道', trigger: 'blur'},
        ],
        position: [
          {required: true, message: '请输入职位', trigger: 'blur'},
        ],
        // emailAddress: [
        //   {required: true, message: '请输入邮箱地址', trigger: 'blur'},
        //   {validator: this.validateEmail, trigger: 'blur'}
        // ],
        channelManager: [
          {required: true, message: '请输入渠道经理', trigger: 'blur'},
        ],
        phone: [
          {validator: this.validatePhone, trigger: 'blur'}
        ],
        // paperInvite: [
        //   {required: true, message: '请选择纸质邀请函', trigger: 'change'},
        // ]
      },
      importVisiable: false,
      importData: [],
      actionUrl: "",
      file: null,
      importError: false,
      pageSize: 30,
      currentPage: 0,
      total: 0,
      channelOptions: [],
      channelManagerOptions: [],
      recordsVisible: false,
      inviteEmailLoading: false,
      tableLoading: false,
      recordsList: [],
    }
  },
  computed: {
    tableColumns() {
      return this.columns.filter((_) => !_.onTable);
    },
    addTableColumns() {
      const list = this.columns.filter((_) => !_.onTable);
      return [
        ...list,
        {prop: 'orderNum', label: "排序"},
      ];
    },
  },
  methods: {
    getSelectLabel(item, row) {
      const { prop, options } = item;
      const itemData = options.find((_) => _.value === row[prop]) || {};
      return itemData.label;
    },
    onRecordsClose() {
      this.recordsVisible = false;
      this.recordsList = [];
    },
    async emailRecords(row) {
      try {
        this.tableLoading = true;
        const res = await queryEmailRecord({ clientId: row.clientId, eventId })
        this.recordsVisible = true;
        this.recordsList = (res.emailSendTimeList || []).map((_) => ({
          updateTime: _ ? moment(new Date(_)).format('YYYY-MM-DD HH:mm:ss') : '',
        }));
      } finally {
        this.tableLoading = false;
      }
    },
    selectable(row) {
      return row.canSendEmail === WHETHER_YES;
    },
    async emailSending(list) {
      try {
        this.tableLoading = true;
        const res = await sendInviteEmail({ clientIdList: list, eventId });
        if (res.code === '0') {
          this.$message.success('邮件已发送')
          this.queryData(1);
        } else {
          this.$message.error('操作失败')
        }
      } finally {
        this.tableLoading = false;
      }
    },
    async onBatchSend() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请勾选发送客户")
        return;
      }
      const clientId = this.multipleSelection.map((_) => _.clientId);
      try {
        this.inviteEmailLoading = true;
        const res = await sendInviteEmail({ clientIdList: clientId, eventId });
        if (res.code === '0') {
          // this.$message.success('邮件已发送')
          this.$alert('<div style="font-size: 16px;">邮件已发送</div>', '', {
            dangerouslyUseHTMLString: true,
          });
          this.queryData(1);
        } else {
          this.$message.error('操作失败')
        }
      } finally {
        this.inviteEmailLoading = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onReset() {
      this.searchParams = {};
      this.queryData(1);
      // this.$refs.form.resetFields();
      // console.log(this.$refs.form, 'this.$refs.form=======')
    },
    validatePhone(rule, value, callback) {
      if (value && !getMobileTest(value)) {
        callback(new Error('手机号格式有误，请您再次确认。'));
      } else {
        callback();
      }
    },
    validateEmail(rule, value, callback) {
      // 自定义校验逻辑
      if (value && !isValidEmail(value)) {
        callback(new Error('邮箱地址格式错误!'));
      } else {
        callback();
      }
    },
    queryDataByPage(page) {
      this.currentPage = page
      this.queryData()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryDataByPage(1);
    },
    async queryData(page) {
      if (page) {
        this.currentPage = page
      }
      if (this.currentPage === 1) {
        this.onQueryOptions()
      }
      this.multipleSelection = [];
      try {
        this.tableLoading = true;
        let res = await queryClientList({...this.searchParams, pageSize: this.pageSize, offset: this.currentPage - 1})
        if (res) {
          let {code, msg, clientDetails, total} = res
          if (code === '0') {
            this.tableData = clientDetails && Array.isArray(clientDetails) ? clientDetails : []
            this.total = total
          } else {
            this.tableData = []
            this.total = 0
            this.$message.error(msg || "服务异常，请联系客服")
          }
        }
      } finally {
        this.tableLoading = false;
      }
    },
    exportData: lodash.debounce(async function () {
      let response = await fetch(concatUrl(`/user/exportClient`), {
        method: 'POST',
        body: JSON.stringify({...this.searchParams, eventId}),
        credentials: 'include',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'token': localCache.get('token'),
        }
      })
      // let contentDisposition = response.headers.get('content-disposition')
      // let fileName = contentDisposition ? contentDisposition.split('filename=')[1] : "白名单"

      const fileName = decodeURI("白名单")
      const blob = await response.blob() //返回完整的二进制数据
      // 创建下载的链接
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      // 释放掉blob对象
      window.URL.revokeObjectURL(href);
    }, 300),
    toggleVisiable(row) {
      if (row && row.clientId) {
        this.addOrUpdateTitle = "编辑"
        for (let key in this.addOrUpdateForm) {
          this.addOrUpdateForm[key] = row[key]
        }
      } else {
        this.addOrUpdateTitle = "个人新增"
        for (let key in this.addOrUpdateForm) {
          if (['canSendEmail', 'paperInvite'].includes(key)) {
            this.addOrUpdateForm[key] = WHETHER_NO
          } else {
            this.addOrUpdateForm[key] = ""
          }
        }
      }
      this.addOrUpdateVisiable = true
    },
    closeAddOrUpdate() {
      this.$refs.addOrUpdateForm.clearValidate()
      this.addOrUpdateVisiable = false
    },
    toggleImportVisiable() {
      this.importData = []
      this.importVisiable = true
      this.importError = false
    },
    async onUpload(request) {
      let file = request.file
      let res = await importClient(file)
      if (res) {
        let {code, msg, details} = res
        this.importError = code !== '0'
        if (!Array.isArray(details) && msg) {
          this.$message.error(msg)
        }
        this.importData = Array.isArray(details) ? [...details] : []
        if (code === '0') {
          this.queryData(1)
        }
      }
    },
    addOrUpdateClient: lodash.debounce(function () {
      this.$refs.addOrUpdateForm.validate(async valid => {
        if (valid) {
          let {clientId, branch, position, channel, name, channelManager, phone} = this.addOrUpdateForm
          let operation = clientId ? OperationEdit : OperationAdd
          let res = await addOrUpdateOrDeleteClient({
            ...this.addOrUpdateForm,
            clientId,
            branch,
            position,
            operation,
            channel,
            name,
            channelManager,
            phone
          })
          if (res) {
            let {code, msg} = res
            if (code === '0') {
              this.$message({
                message: clientId ? "更新成功" : "新增成功",
                type: 'success',
              });
              this.addOrUpdateVisiable = false
              this.queryData(1)
            } else {
              this.$message.error(msg || "服务异常，请联系客服")
            }
          }
        } else {
          return false
        }
      })
    }, 300),
    deleteClient(clientId) {
      if (!clientId) {
        return
      }
      this.$confirm("确认删除?", '删除', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: "error"
      }).then(async () => {
        let res = await addOrUpdateOrDeleteClient({clientId, operation: OperationDel})
        if (res) {
          let {code, msg} = res
          if (code === '0') {
            this.$message.success("删除成功")
            this.queryData()
          } else {
            this.$message.error(msg || "服务异常，请联系客服")
          }
        }
      }).catch(() => {
      });
    },
    downloadTemplate: lodash.debounce(async function () {
      let response = await fetch(concatUrl(`/user/downloadWhiteList`), {
        method: 'POST',
        body: JSON.stringify({...this.searchParams, eventId}),
        credentials: 'include',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'token': localCache.get('token'),
        }
      })
      const fileName = decodeURI("批量导入模板")
      const blob = await response.blob() //返回完整的二进制数据
      // 创建下载的链接
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      // 释放掉blob对象
      window.URL.revokeObjectURL(href);
    }, 300),
    onQueryOptions() {
      getQueryChannel().then(channelOptionsRes => {
        this.channelOptions = channelOptionsRes && channelOptionsRes.data ? channelOptionsRes.data.map(val => ({label: val, value: val})) : []
      }).catch(err => {
        this.channelOptions = []
      })
      getQueryChannelManager().then(channelManagerOptionsRes => {
        this.channelManagerOptions = channelManagerOptionsRes && channelManagerOptionsRes.data ? channelManagerOptionsRes.data.map(val => ({label: val, value: val})) : []
      }).catch(err => {
        this.channelManagerOptions = []
      })
    }
  },
  mounted() {
    this.onQueryOptions()
    this.queryData(1)
  },
}
</script>

<style lang="less">
.invitationClientManage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .el-form {
    margin-top: 18px;
  }

  .invitationClientManage-form {
    display: flex;
    flex-wrap: wrap;
  }

  .el-form-item {
    margin-bottom: 18px;
  }

  > div, > .el-form {
    width: 100%;
  }

  .el-table th,
  .el-table td {
    padding: 5px 0;
  }

  .table-button {
    padding: 8px;
  }
}

.invitation-import-dialog {
  .el-dialog__body {
    padding: 14px 20px 30px;
  }

  .upload-button {
    display: inline-block;
    margin-right: 18px;
  }
}
</style>

